import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=60474a8d&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=60474a8d&prod&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=60474a8d&prod&lang=scss"
import style2 from "./Index.vue?vue&type=style&index=2&id=60474a8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_underscore@1.13.8_vue-t_oz4jpprlle4dra2pgsz5us5kba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60474a8d",
  null
  
)

export default component.exports